module.exports = __webpack_public_path__ + "static/media/5DPO3.4c08f17a.jpg";